
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./DashboardAudienceBuilder": () => {
return Promise.all(/*  | __federation_expose_DashboardAudienceBuilder */ [__webpack_require__.e("965"), __webpack_require__.e("948"), __webpack_require__.e("540"), __webpack_require__.e("397"), __webpack_require__.e("285"), __webpack_require__.e("380"), __webpack_require__.e("168"), __webpack_require__.e("79"), __webpack_require__.e("139")]).then(() => (() => (__webpack_require__(4873))));
},
"./staticRemoteData": () => {
return __webpack_require__.e(/*  | __federation_expose_staticRemoteData */ "968").then(() => (() => (__webpack_require__(60662))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };